export default __webpack_public_path__ + "static/cs-solution-architecture-167f870896f12d10c66a3d60777ab88a.png";